import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CalendarClock, LayoutDashboard, Clock, LayoutTemplate, CalendarCheck, LogOut } from "lucide-react";

const tabs = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard-tab" },
  { to: "/availability", label: "Availability", icon: Clock, testid: "nav-availability-tab" },
  { to: "/templates", label: "Templates", icon: LayoutTemplate, testid: "nav-templates-tab" },
  { to: "/bookings", label: "Bookings", icon: CalendarCheck, testid: "nav-bookings-tab" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/dashboard")} data-testid="cliq2book-logo">
              <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center">
                <CalendarClock className="w-4.5 h-4.5 text-white" />
              </div>
              <span className="text-lg font-extrabold tracking-tight">Cliq2Book</span>
            </div>

            <nav className="hidden md:flex items-center gap-1">
              {tabs.map((t) => (
                <NavLink key={t.to} to={t.to} data-testid={t.testid}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-100"
                    }`
                  }>
                  <t.icon className="w-4 h-4" /> {t.label}
                </NavLink>
              ))}
            </nav>

            <div className="flex items-center gap-3">
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-8 h-8 rounded-full border border-slate-200" />
              ) : (
                <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-xs font-semibold">
                  {user?.name?.[0] || "U"}
                </div>
              )}
              <button onClick={logout} data-testid="logout-btn"
                className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition-colors">
                <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          </div>

          <nav className="md:hidden flex items-center gap-1 pb-3 overflow-x-auto">
            {tabs.map((t) => (
              <NavLink key={t.to} to={t.to}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap ${
                    isActive ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-100"
                  }`
                }>
                <t.icon className="w-4 h-4" /> {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
}
